// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Fetch = require("bs-fetch/src/Fetch.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Log$SmartcutsMacros = require("../../bs-macros-extension/src/Log.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Exceptions$SmartcutsMacros = require("../../bs-macros-extension/src/Exceptions.bs.js");
var JsExnUtils$SmartcutsMacros = require("../../bs-utils/src/JsExnUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../bs-utils/src/PromiseUtils.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../bs-utils/src/JsPromiseErrorUtils.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "message",
                Decco.stringToJson(v.message)
              ],
              [
                "extensions",
                Decco.dictToJson((function (v) {
                        return v;
                      }), v.extensions)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var message = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
  if (message.TAG === /* Ok */0) {
    var extensions = Decco.dictFromJson((function (v) {
            return {
                    TAG: /* Ok */0,
                    _0: v
                  };
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "extensions"), null));
    if (extensions.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                message: message._0,
                extensions: extensions._0
              }
            };
    }
    var e = extensions._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".extensions" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = message._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".message" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var $$Error = {
  t_encode: t_encode,
  t_decode: t_decode
};

var FaunaResponseBody = {
  $$Error: $$Error
};

function authenticationError_encode(v) {
  return Js_dict.fromArray([
              [
                "status",
                Decco.intToJson(v.status)
              ],
              [
                "bodyText",
                Decco.stringToJson(v.bodyText)
              ]
            ]);
}

function authenticationError_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var status = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
  if (status.TAG === /* Ok */0) {
    var bodyText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bodyText"), null));
    if (bodyText.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                status: status._0,
                bodyText: bodyText._0
              }
            };
    }
    var e = bodyText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".bodyText" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = status._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".status" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "status",
                Decco.intToJson(v.status)
              ],
              [
                "bodyText",
                Decco.stringToJson(v.bodyText)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var status = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
  if (status.TAG === /* Ok */0) {
    var bodyText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bodyText"), null));
    if (bodyText.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                status: status._0,
                bodyText: bodyText._0
              }
            };
    }
    var e = bodyText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".bodyText" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = status._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".status" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var OtherNon2xxError = {
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

function t_encode$2(v) {
  if (typeof v === "number") {
    switch (v) {
      case /* PayloadTooLarge */0 :
          return ["PayloadTooLarge"];
      case /* MissingAuthorizationHeader */1 :
          return ["MissingAuthorizationHeader"];
      case /* InvalidAuthorizationHeader */2 :
          return ["InvalidAuthorizationHeader"];
      case /* InvalidDatabaseSecret */3 :
          return ["InvalidDatabaseSecret"];
      case /* InternalServerError */4 :
          return ["InternalServerError"];
      case /* ServiceNotAvailable */5 :
          return ["ServiceNotAvailable"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* FailedToFetch */0 :
          return [
                  "FailedToFetch",
                  JsExnUtils$SmartcutsMacros.t_encode(v._0)
                ];
      case /* AuthenticationError */1 :
          return [
                  "AuthenticationError",
                  authenticationError_encode(v._0)
                ];
      case /* NoKeyFoundForSecret */2 :
          return [
                  "NoKeyFoundForSecret",
                  Decco.stringToJson(v._0)
                ];
      case /* JsExnError */3 :
          return [
                  "JsExnError",
                  JsExnUtils$SmartcutsMacros.t_encode(v._0)
                ];
      case /* OtherJsPromiseError */4 :
          return [
                  "OtherJsPromiseError",
                  Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
                ];
      case /* OtherErrors */5 :
          return [
                  "OtherErrors",
                  Decco.arrayToJson(t_encode, v._0)
                ];
      case /* OtherNon2xxErrors */6 :
          return [
                  "OtherNon2xxErrors",
                  t_encode$1(v._0)
                ];
      case /* MissingInExpectedJson */7 :
          return [
                  "MissingInExpectedJson",
                  Decco.arrayToJson(Decco.stringToJson, v._0),
                  v._1
                ];
      
    }
  }
}

function t_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AuthenticationError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = authenticationError_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* AuthenticationError */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "FailedToFetch" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailedToFetch */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "InternalServerError" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* InternalServerError */4
                  };
          }
      case "InvalidAuthorizationHeader" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* InvalidAuthorizationHeader */2
                  };
          }
      case "InvalidDatabaseSecret" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* InvalidDatabaseSecret */3
                  };
          }
      case "JsExnError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* JsExnError */3,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "MissingAuthorizationHeader" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* MissingAuthorizationHeader */1
                  };
          }
      case "MissingInExpectedJson" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = {
            TAG: /* Ok */0,
            _0: Belt_Array.getExn(jsonArr$1, 2)
          };
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* MissingInExpectedJson */7,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$3 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "NoKeyFoundForSecret" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NoKeyFoundForSecret */2,
                      _0: v0$3._0
                    }
                  };
          }
          var e$5 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "OtherErrors" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.arrayFromJson(t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OtherErrors */5,
                      _0: v0$4._0
                    }
                  };
          }
          var e$6 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "OtherJsPromiseError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OtherJsPromiseError */4,
                      _0: v0$5._0
                    }
                  };
          }
          var e$7 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "OtherNon2xxErrors" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OtherNon2xxErrors */6,
                      _0: v0$6._0
                    }
                  };
          }
          var e$8 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "PayloadTooLarge" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PayloadTooLarge */0
                  };
          }
      case "ServiceNotAvailable" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ServiceNotAvailable */5
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function toHumanReadable(error) {
  if (typeof error === "number") {
    switch (error) {
      case /* PayloadTooLarge */0 :
          return "Payload too large";
      case /* MissingAuthorizationHeader */1 :
          return "Missing Authorization header";
      case /* InvalidAuthorizationHeader */2 :
          return "Invalid Authorization header";
      case /* InvalidDatabaseSecret */3 :
          return "Invalid Database Secret";
      case /* InternalServerError */4 :
          return "Internal Server Error";
      case /* ServiceNotAvailable */5 :
          return "Service Not Available";
      
    }
  } else {
    switch (error.TAG | 0) {
      case /* FailedToFetch */0 :
          var arg = error._0.message;
          return "Failed to fetch: " + (function (param) {
                      return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                    })("An error occurred");
      case /* AuthenticationError */1 :
          var match = error._0;
          return "Authentication error (" + (String(match.status) + (": " + match.bodyText));
      case /* NoKeyFoundForSecret */2 :
          return "No key found for secret";
      case /* JsExnError */3 :
          var arg$1 = error._0.message;
          var param = "An error occurred";
          return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
      case /* OtherJsPromiseError */4 :
          return "An error occurred during the promise";
      case /* OtherErrors */5 :
          return Belt_Array.reduceWithIndex(error._0, "Other errors: ", (function (cumulativeMsg, param, index) {
                        return cumulativeMsg + ((
                                  index === 0 ? "" : "; "
                                ) + param.message);
                      }));
      case /* OtherNon2xxErrors */6 :
          var match$1 = error._0;
          return String(match$1.status) + (" error: " + match$1.bodyText);
      case /* MissingInExpectedJson */7 :
          return "Missing " + (error._0.join(".") + (" in " + JSON.stringify(error._1)));
      
    }
  }
}

function fromApolloClientError(apolloError) {
  var networkError = apolloError.networkError;
  var graphQLErrors = apolloError.graphQLErrors;
  if (Belt_Array.some(graphQLErrors, (function (err) {
            return err.message.startsWith("Missing authorization header");
          }))) {
    return /* MissingAuthorizationHeader */1;
  }
  if (Belt_Array.some(graphQLErrors, (function (err) {
            return err.message.startsWith("Invalid authorization header");
          }))) {
    return /* InvalidAuthorizationHeader */2;
  }
  if (Belt_Array.some(graphQLErrors, (function (err) {
            return err.message.startsWith("Invalid database secret");
          }))) {
    return /* InvalidDatabaseSecret */3;
  }
  if (networkError === undefined) {
    return {
            TAG: /* OtherErrors */5,
            _0: []
          };
  }
  switch (networkError.TAG | 0) {
    case /* FetchFailure */0 :
        var jsExn = networkError._0;
        var msg = jsExn.message;
        if (msg !== undefined) {
          if (msg.startsWith("Missing authorization header")) {
            return /* MissingAuthorizationHeader */1;
          } else if (msg.startsWith("Invalid authorization header")) {
            return /* InvalidAuthorizationHeader */2;
          } else if (msg.startsWith("Invalid database secret")) {
            return /* InvalidDatabaseSecret */3;
          } else {
            return {
                    TAG: /* FailedToFetch */0,
                    _0: jsExn
                  };
          }
        } else {
          return {
                  TAG: /* FailedToFetch */0,
                  _0: jsExn
                };
        }
    case /* BadStatus */1 :
        var status = networkError._0;
        if (status !== 401) {
          if (status !== 413) {
            return {
                    TAG: /* OtherNon2xxErrors */6,
                    _0: {
                      status: status,
                      bodyText: ""
                    }
                  };
          } else {
            console.warn("Graphql payload too large. Make sure the payload is less than 1,020 kb");
            return /* PayloadTooLarge */0;
          }
        }
        var message = networkError._1.message;
        if (message.startsWith("Missing authorization header")) {
          return /* MissingAuthorizationHeader */1;
        } else if (message.startsWith("Invalid authorization header")) {
          return /* InvalidAuthorizationHeader */2;
        } else if (message.startsWith("Invalid database secret")) {
          return /* InvalidDatabaseSecret */3;
        } else {
          return {
                  TAG: /* AuthenticationError */1,
                  _0: {
                    status: 401,
                    bodyText: ""
                  }
                };
        }
    case /* BadBody */2 :
    case /* ParseError */3 :
        return {
                TAG: /* OtherErrors */5,
                _0: []
              };
    
  }
}

function consoleError(error) {
  if (typeof error === "number") {
    switch (error) {
      case /* PayloadTooLarge */0 :
          console.error("Payload too large");
          return ;
      case /* MissingAuthorizationHeader */1 :
          console.error("Missing Authorization header");
          return ;
      case /* InvalidAuthorizationHeader */2 :
          console.error("Invalid Authorization header");
          return ;
      case /* InvalidDatabaseSecret */3 :
          console.error("Invalid Database Secret");
          return ;
      case /* InternalServerError */4 :
          console.error("Internal Server Error");
          return ;
      case /* ServiceNotAvailable */5 :
          console.error("Service Not Available");
          return ;
      
    }
  } else {
    switch (error.TAG | 0) {
      case /* AuthenticationError */1 :
          var match = error._0;
          console.error("Authentication error", match.status, match.bodyText);
          return ;
      case /* NoKeyFoundForSecret */2 :
          console.error("No key found for secret");
          return ;
      case /* OtherErrors */5 :
          return Belt_Array.forEach(error._0, (function (param) {
                        console.error("Other error", param.message, param.extensions);
                        
                      }));
      case /* OtherNon2xxErrors */6 :
          console.error("Other non-2xx error", JSON.stringify(error._0));
          return ;
      case /* MissingInExpectedJson */7 :
          var json = error._1;
          console.error("Missing " + (error._0.join(".") + (" in " + JSON.stringify(json))), json);
          return ;
      default:
        console.error(error._0);
        return ;
    }
  }
}

function isAuthIssue(error) {
  if (typeof error === "number") {
    switch (error) {
      case /* MissingAuthorizationHeader */1 :
      case /* InvalidAuthorizationHeader */2 :
      case /* InvalidDatabaseSecret */3 :
          return true;
      default:
        return false;
    }
  } else {
    switch (error.TAG | 0) {
      case /* AuthenticationError */1 :
      case /* NoKeyFoundForSecret */2 :
          return true;
      default:
        return false;
    }
  }
}

function handleWithRaise(error, context) {
  if (typeof error === "number") {
    switch (error) {
      case /* PayloadTooLarge */0 :
          return Util$SmartcutsMacros.logAndRaiseJsError("Payload too large when " + context);
      case /* MissingAuthorizationHeader */1 :
          return Util$SmartcutsMacros.logAndRaiseJsError("Missing Authorization header when " + context);
      case /* InvalidAuthorizationHeader */2 :
          return Util$SmartcutsMacros.logAndRaiseJsError("Invalid Authorization header when " + context);
      case /* InvalidDatabaseSecret */3 :
          return Util$SmartcutsMacros.logAndRaiseJsError("Invalid secret when " + context);
      case /* InternalServerError */4 :
          throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.FaunaGraphql.Internal_server_error,
                Error: new Error()
              };
      case /* ServiceNotAvailable */5 :
          throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.FaunaGraphql.Service_not_available,
                Error: new Error()
              };
      
    }
  } else {
    switch (error.TAG | 0) {
      case /* FailedToFetch */0 :
          console.error("Failed to fetch", error._0);
          return Util$SmartcutsMacros.logAndRaiseJsError("Failed to fetch from db when " + context);
      case /* AuthenticationError */1 :
          console.error("Auth error", error._0);
          return Util$SmartcutsMacros.logAndRaiseJsError("Auth error when " + context);
      case /* NoKeyFoundForSecret */2 :
          return Util$SmartcutsMacros.logAndRaiseJsError("No key found for secret when " + context);
      case /* JsExnError */3 :
      case /* OtherJsPromiseError */4 :
          console.error(error._0);
          return Util$SmartcutsMacros.logAndRaiseJsError("Encountered an error when " + context);
      case /* OtherErrors */5 :
          return Util$SmartcutsMacros.logAndRaiseJsError("Faunadb returned errors when " + (context + (": " + StringUtils$SmartcutsMacros.join(", ", $$Array.to_list(Belt_Array.map(error._0, (function (error) {
                                        return JSON.stringify(error);
                                      })))))));
      case /* OtherNon2xxErrors */6 :
          return Util$SmartcutsMacros.logAndRaiseJsError("Faunadb returned errors: " + JSON.stringify(error._0));
      case /* MissingInExpectedJson */7 :
          return Util$SmartcutsMacros.logAndRaiseJsError("Failed to save some command log entries because missing " + (error._0.join(".") + (" in " + (JSON.stringify(error._1) + (" when " + context)))));
      
    }
  }
}

var FaunaGraphqlError = {
  authenticationError_encode: authenticationError_encode,
  authenticationError_decode: authenticationError_decode,
  OtherNon2xxError: OtherNon2xxError,
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  toHumanReadable: toHumanReadable,
  fromApolloClientError: fromApolloClientError,
  consoleError: consoleError,
  isAuthIssue: isAuthIssue,
  handleWithRaise: handleWithRaise
};

function raiseIfError(result, context) {
  if (result.TAG === /* Ok */0) {
    return result;
  } else {
    return handleWithRaise(result._0, context);
  }
}

var FaunaGraphqlResult = {
  raiseIfError: raiseIfError
};

function sendGraphqlQueryExn(token, queryString, maybeVariables, parse, param) {
  var arg = OptionUtils$SmartcutsMacros.map(maybeVariables, (function (variables) {
          return {
                  hd: [
                    "variables",
                    variables
                  ],
                  tl: /* [] */0
                };
        }));
  return fetch("https://graphql.fauna.com/graphql", Fetch.RequestInit.make(/* Post */2, {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + token,
                      "X-Schema-Preview": "partial-update-mutation"
                    }, Caml_option.some(JSON.stringify(Js_dict.fromList(List.append({
                                      hd: [
                                        "query",
                                        queryString
                                      ],
                                      tl: /* [] */0
                                    }, (function (param) {
                                          return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                        })(/* [] */0))))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function (res) {
              var status = res.status;
              if (status !== 401) {
                if (status !== 413) {
                  if (status >= 200 && status < 300) {
                    return res.json().then(function (json) {
                                var errors = json.errors;
                                var data = json.data;
                                var tmp;
                                if (data == null) {
                                  if (errors !== undefined) {
                                    if (errors.length !== 1) {
                                      tmp = {
                                        TAG: /* Error */1,
                                        _0: {
                                          TAG: /* OtherErrors */5,
                                          _0: errors
                                        }
                                      };
                                    } else {
                                      var match = errors[0];
                                      var message = match.message;
                                      switch (message) {
                                        case "An internal server error occurred. Please contact Fauna support." :
                                            tmp = {
                                              TAG: /* Error */1,
                                              _0: /* InternalServerError */4
                                            };
                                            break;
                                        case "Invalid authorization header" :
                                        case "Invalid authorization header." :
                                            tmp = {
                                              TAG: /* Error */1,
                                              _0: /* InvalidAuthorizationHeader */2
                                            };
                                            break;
                                        case "Invalid database secret" :
                                        case "Invalid database secret." :
                                            tmp = {
                                              TAG: /* Error */1,
                                              _0: /* InvalidDatabaseSecret */3
                                            };
                                            break;
                                        case "Missing authorization header" :
                                        case "Missing authorization header." :
                                            tmp = {
                                              TAG: /* Error */1,
                                              _0: /* MissingAuthorizationHeader */1
                                            };
                                            break;
                                        case "The service is currently unavailable" :
                                        case "The service is currently unavailable." :
                                            tmp = {
                                              TAG: /* Error */1,
                                              _0: /* ServiceNotAvailable */5
                                            };
                                            break;
                                        default:
                                          if (message.startsWith("No key found for secret ")) {
                                            var messageRe = /No key found for secret (.+)\./;
                                            var result = messageRe.exec(message);
                                            var arg = result !== null ? Caml_option.nullable_to_opt(Caml_array.get(result, 1)) : undefined;
                                            var secret = (function (param) {
                                                  return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                                })("<unkown_token>");
                                            tmp = {
                                              TAG: /* Error */1,
                                              _0: {
                                                TAG: /* NoKeyFoundForSecret */2,
                                                _0: secret
                                              }
                                            };
                                          } else {
                                            tmp = {
                                              TAG: /* Error */1,
                                              _0: {
                                                TAG: /* OtherErrors */5,
                                                _0: errors
                                              }
                                            };
                                          }
                                      }
                                    }
                                  } else {
                                    tmp = Util$SmartcutsMacros.logAndRaiseJsError("Expect faunadb response to have at least data or errors");
                                  }
                                } else if (errors !== undefined) {
                                  Curry._2(Log$SmartcutsMacros.fauna.log2, "data", data);
                                  Curry._2(Log$SmartcutsMacros.fauna.error2, "error", errors);
                                  tmp = Util$SmartcutsMacros.logAndRaiseJsError("Faunadb response cannot have both data and errors");
                                } else {
                                  tmp = {
                                    TAG: /* Ok */0,
                                    _0: Curry._1(parse, data)
                                  };
                                }
                                return Promise.resolve(tmp);
                              });
                  } else {
                    return res.text().then(function (bodyText) {
                                return Promise.resolve({
                                            TAG: /* Error */1,
                                            _0: {
                                              TAG: /* OtherNon2xxErrors */6,
                                              _0: {
                                                status: status,
                                                bodyText: bodyText
                                              }
                                            }
                                          });
                              });
                  }
                } else {
                  console.warn("Graphql payload too large. Make sure the payload is less than 1,020 kb");
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: /* PayloadTooLarge */0
                            });
                }
              } else {
                return res.json().then(function (json) {
                            var errors = json.errors;
                            if (errors === undefined) {
                              return res.text().then(function (bodyText) {
                                          return Promise.resolve({
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        TAG: /* AuthenticationError */1,
                                                        _0: {
                                                          status: status,
                                                          bodyText: bodyText
                                                        }
                                                      }
                                                    });
                                        });
                            }
                            var match = $$Array.to_list(errors);
                            var tmp;
                            if (match) {
                              switch (match.hd.message) {
                                case "Invalid authorization header" :
                                    tmp = match.tl ? ({
                                          TAG: /* Error */1,
                                          _0: {
                                            TAG: /* OtherErrors */5,
                                            _0: errors
                                          }
                                        }) : ({
                                          TAG: /* Error */1,
                                          _0: /* InvalidAuthorizationHeader */2
                                        });
                                    break;
                                case "Invalid database secret" :
                                    tmp = match.tl ? ({
                                          TAG: /* Error */1,
                                          _0: {
                                            TAG: /* OtherErrors */5,
                                            _0: errors
                                          }
                                        }) : ({
                                          TAG: /* Error */1,
                                          _0: /* InvalidDatabaseSecret */3
                                        });
                                    break;
                                case "Missing authorization header" :
                                    tmp = match.tl ? ({
                                          TAG: /* Error */1,
                                          _0: {
                                            TAG: /* OtherErrors */5,
                                            _0: errors
                                          }
                                        }) : ({
                                          TAG: /* Error */1,
                                          _0: /* MissingAuthorizationHeader */1
                                        });
                                    break;
                                default:
                                  tmp = {
                                    TAG: /* Error */1,
                                    _0: {
                                      TAG: /* OtherErrors */5,
                                      _0: errors
                                    }
                                  };
                              }
                            } else {
                              tmp = {
                                TAG: /* Error */1,
                                _0: {
                                  TAG: /* OtherErrors */5,
                                  _0: errors
                                }
                              };
                            }
                            return Promise.resolve(tmp);
                          });
              }
            });
}

function maybeNetworkFailure(error) {
  var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, error);
  if (typeof jsExn === "number") {
    return ;
  }
  if (jsExn.TAG !== /* JsExn */0) {
    return ;
  }
  var jsExn$1 = jsExn._0;
  if (Caml_obj.caml_equal(jsExn$1.name, "TypeError") && Caml_obj.caml_equal(jsExn$1.message, "Failed to fetch")) {
    return Caml_option.some(jsExn$1);
  }
  
}

function maybeAuthFailure(error) {
  var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, error);
  if (typeof jsExn === "number") {
    return ;
  }
  if (jsExn.TAG !== /* JsExn */0) {
    return ;
  }
  var jsExn$1 = jsExn._0;
  var message = jsExn$1.message;
  if (message !== undefined && message.startsWith("No key found for secret")) {
    return Caml_option.some(jsExn$1);
  }
  
}

function sendGraphqlQuery(token, queryString, variables, parse, param) {
  return sendGraphqlQueryExn(token, queryString, variables, parse, undefined).catch(function (error) {
              var jsExn = maybeNetworkFailure(error);
              if (jsExn !== undefined) {
                console.warn("No internet connection");
                console.error(error);
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* FailedToFetch */0,
                              _0: Caml_option.valFromOption(jsExn)
                            }
                          });
              }
              var _jsExn = maybeAuthFailure(error);
              if (_jsExn !== undefined) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: /* InvalidDatabaseSecret */3
                          });
              } else {
                console.error(error);
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* OtherJsPromiseError */4,
                              _0: error
                            }
                          });
              }
            });
}

function shouldRetryForJsPromiseError(error) {
  var _jsExn = maybeNetworkFailure(error);
  if (_jsExn !== undefined) {
    return true;
  }
  var match = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, error);
  if (typeof match === "number") {
    return match >= 3;
  } else {
    return false;
  }
}

function sendGraphqlQueryAndRetryIfNetworkError(retriesOpt, token, queryString, variables, parse, param) {
  var retries = retriesOpt !== undefined ? retriesOpt : 3;
  var match = PromiseUtils$SmartcutsMacros.withRetries(retries, (function (param, param$1) {
          return sendGraphqlQueryExn(token, queryString, variables, parse, undefined).then(function (result) {
                      if (result.TAG === /* Ok */0) {
                        return Promise.resolve(result);
                      }
                      var match = result._0;
                      if (typeof match === "number") {
                        if (match !== 4) {
                          if (match >= 5) {
                            return Promise.reject({
                                        RE_EXN_ID: Exceptions$SmartcutsMacros.FaunaGraphql.Service_not_available
                                      });
                          } else {
                            return Promise.resolve(result);
                          }
                        } else {
                          return Promise.reject({
                                      RE_EXN_ID: Exceptions$SmartcutsMacros.FaunaGraphql.Internal_server_error
                                    });
                        }
                      } else {
                        return Promise.resolve(result);
                      }
                    });
        }), shouldRetryForJsPromiseError, undefined, undefined);
  var doPromise = match[0];
  return [
          (function (param) {
              return Curry._1(doPromise, undefined).catch(function (error) {
                          var _jsExn = maybeAuthFailure(error);
                          if (_jsExn !== undefined) {
                            return Promise.resolve({
                                        TAG: /* Error */1,
                                        _0: /* InvalidDatabaseSecret */3
                                      });
                          } else {
                            console.error(error);
                            return Promise.resolve({
                                        TAG: /* Error */1,
                                        _0: {
                                          TAG: /* OtherJsPromiseError */4,
                                          _0: error
                                        }
                                      });
                          }
                        });
            }),
          match[1]
        ];
}

function fetchAllInner(client, pageSize, maybeCursor, doSinglePageQuery, outputDataAndMaybeCursorFromQueryResultData) {
  return Curry._3(doSinglePageQuery, client, pageSize, maybeCursor).then(function (result) {
              if (result.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: fromApolloClientError(result._0)
                          });
              }
              var match = Curry._1(outputDataAndMaybeCursorFromQueryResultData, result._0);
              var maybeCursor = match[1];
              var data = match[0];
              if (maybeCursor !== undefined && data.length === pageSize) {
                return fetchAllInner(client, pageSize, maybeCursor, doSinglePageQuery, outputDataAndMaybeCursorFromQueryResultData).then(function (result) {
                            return Promise.resolve(Belt_Result.map(result, (function (dataNextPage) {
                                              return $$Array.append(data, dataNextPage);
                                            })));
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: data
                          });
              }
            });
}

function fetchAll(client, pageSize, doSinglePageQuery, outputDataAndMaybeCursorFromQueryResultData) {
  return fetchAllInner(client, pageSize, undefined, doSinglePageQuery, outputDataAndMaybeCursorFromQueryResultData);
}

exports.FaunaResponseBody = FaunaResponseBody;
exports.FaunaGraphqlError = FaunaGraphqlError;
exports.FaunaGraphqlResult = FaunaGraphqlResult;
exports.sendGraphqlQueryExn = sendGraphqlQueryExn;
exports.maybeNetworkFailure = maybeNetworkFailure;
exports.maybeAuthFailure = maybeAuthFailure;
exports.sendGraphqlQuery = sendGraphqlQuery;
exports.shouldRetryForJsPromiseError = shouldRetryForJsPromiseError;
exports.sendGraphqlQueryAndRetryIfNetworkError = sendGraphqlQueryAndRetryIfNetworkError;
exports.fetchAllInner = fetchAllInner;
exports.fetchAll = fetchAll;
/* Log-SmartcutsMacros Not a pure module */
